var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center align-center",style:({ width: _vm.width, height: _vm.width })},[_c('img',{attrs:{"width":"82%","src":_vm.imageSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }